import React from 'react';
import DatePicker from 'react-datepicker';
import Colors from '@theme/colors';

import 'react-datepicker/dist/react-datepicker.css';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { mq } from '@helpers/breakpoints';

const FormDateInput = (props: any) => {
  const {
    onChange,
    setFieldTouched,
    value,
    className,
    dateFormat = 'yyyy-MM-dd',
    error,
    placeholder,
    ...field
  } = props;

  return (
    <div className={className}>
      <DatePicker
        {...field}
        selected={(value && new Date(value)) || ''}
        dateFormat={dateFormat}
        placeholderText={placeholder}
        onChange={(val) => {
          onChange(field.name, val ? val : '').then(() => setFieldTouched(field.name, true));
        }}
      />
    </div>
  );
};

const FormStyledDateInputStyle = ({ width, error, value }) => css`
  .react-datepicker-wrapper {
    width: ${width ? width : '100%'};
  }
  .react-datepicker__input-container {
    input {
      width: 90%;
      height: 100%;
      padding: 0 10px;
      font-size: 16px;
      background-color: ${error ? Colors.redLight4 : Colors.neutral0} !important;
    }
    border-style: solid;
    border-width: 2px;
    height: 56px;
    border-color: ${error ? Colors.redLight1 : Colors.grayLight9};
    background-color: ${error ? Colors.redLight4 : Colors.neutral0};
    border-radius: 8px;
    :focus-within {
      border-color: ${Colors.science37};
    }
    input {
      border: none;
    }
  }
`;
const FormStyledDateInput = styled(FormDateInput)`
  ${FormStyledDateInputStyle}
`;
export { FormStyledDateInput as FormDateInput };
